import { ThemeUICSSObject } from '@apia/theme';
import execution from './execution';
import print from './print';
/* IMPORT HERE */

const views: ThemeUICSSObject = {
  execution,
  print,
  /* PREPEND HERE */
};

export default views;
